/**
 * Lẽ o valor de um metatag na página.
 *
 * @param {string} nome Nome da meta tag
 * @param {*} valorPadrão Valor padrão caso a meta tag não esteja definida
 */
export function meta(nome, valorPadrão = null) {
    let meta = document.head.querySelector(`meta[name="${nome}"]`)
    return (meta && meta.content) || valorPadrão
}

/**
 * Atualiza o valor da meta tag. Se não existir, a meta tag é criada.
 *
 * @param {string} name
 * @param {string} value
 */
export function updateMeta(name, value) {
    let meta = document.head.querySelector(`meta[name="${name}"]`)
    if (!meta) {
        meta = document.createElement('meta')
        meta.setAttribute('name', name)
        document.head.appendChild(meta)
    }

    meta.setAttribute('content', value)
}
